export default "__VITE_ASSET__C06jL7KX__"